import React from 'react';
import InvoicePartyDetailStep from './InvoicePartyDetailStep';

type Props = {
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
};

const SellerDetailStep: React.FC<Props> = ({ onPrevious, onNext }) => (
  <InvoicePartyDetailStep
    party="seller"
    onPrevious={onPrevious}
    onNext={onNext}
  />
);

export default SellerDetailStep;
